import { Instance } from "mobx-state-tree";
import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";

export const RequiredValidatorModel = ValidatorModel.actions((self) => {
  return {
    validate(value: any) {
      if (Array.isArray(value)) {
        if (value.length) return undefined;

        return ValidationMesssageModel.create({
          message: { mainKey: "general.validation.required" },
        });
      }

      if (typeof value === "object" && value !== null) {
        if (value?.id !== 0) return undefined;

        return ValidationMesssageModel.create({
          message: { mainKey: "general.validation.required" },
        });
      }

      if (value || Number.isInteger(value))
        // TODO Number.isInteger(value): strange condition, we need to review it
        return undefined;

      return ValidationMesssageModel.create({
        message: { mainKey: "general.validation.required" },
      });
    },
  };
});

export type RequiredValidator = Instance<typeof RequiredValidatorModel>;
